export default __webpack_public_path__ + "static/media/1939.5254113c.png";